import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { BookingListItem } from "../../../../components/BookingListComponent"

export interface PujaState {
  bookingId: number | string | null
  paymentUrl: string | null
  paymentMethod: string | null
  isFromPaymentPage: boolean | null
  isPaymentSuccess: boolean | null
  pujaDetail: BookingListItem | null
}

const initialState: PujaState = {
  bookingId: null,
  paymentUrl: null,
  isFromPaymentPage: null,
  isPaymentSuccess: null,
  pujaDetail: null,
  paymentMethod: null
}

const pujaState = createSlice({
  name: 'puja',
  initialState,
  reducers: {
    setBookingId: (state, action: PayloadAction<PujaState['bookingId']>) => {
      state.bookingId = action.payload
    },
    setPaymentUrl: (state, action: PayloadAction<PujaState['paymentUrl']>) => {
      state.paymentUrl = action.payload
    },
    setIsPaymentSuccess: (state, action: PayloadAction<PujaState['isPaymentSuccess']>) => {
      state.isPaymentSuccess = action.payload
    },
    setIsFromPaymentPage: (state, action: PayloadAction<PujaState['isFromPaymentPage']>) => {
      state.isFromPaymentPage = action.payload
    },
    setPujaDetail: (state, action: PayloadAction<PujaState['pujaDetail']>) => {
      state.pujaDetail = action.payload
    },
    setPaymentMethod: (state, action: PayloadAction<PujaState['paymentMethod']>) => {
      state.paymentMethod = action.payload
    },
    reset: (state) => {
      state.bookingId = null
      state.isFromPaymentPage = null
      state.isPaymentSuccess = null
      state.paymentUrl = null
      state.pujaDetail = null
      state.paymentMethod = null
    }
  }
})

export const {
  setBookingId,
  setPaymentUrl,
  setIsFromPaymentPage,
  setIsPaymentSuccess,
  setPujaDetail,
  setPaymentMethod,
  reset
} = pujaState.actions
export default pujaState.reducer